import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import { ExecutionResult } from "graphql";
import { UserPasswordRecoveryResult } from "src/types/graphql.d";

const RESET_PASSWORD = gql`
  mutation userPasswordRecovery($email: String!) {
    userPasswordRecovery(email: $email) {
      message
    }
  }
`;

interface ResetPasswordVariables {
  email: string;
}

interface ResetPasswordData {
  userPasswordRecoveryResult: UserPasswordRecoveryResult;
}

interface ResetPasswordHook {
  resetPassword: (email: string) => Promise<ExecutionResult<ResetPasswordData>>;
  data: ResetPasswordData | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const useResetPassword = (): ResetPasswordHook => {
  const [resetPasswordMutation, { loading, data, error }] = useMutation<
    ResetPasswordData,
    ResetPasswordVariables
  >(RESET_PASSWORD);

  const resetPassword = useCallback(
    (email: string) => {
      return resetPasswordMutation({
        variables: {
          email,
        },
      });
    },
    [resetPasswordMutation]
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return { resetPassword, loading, data, error };
};

export { useResetPassword };
